<template>
<div class="scale2"
     :style="scaleStyle"
     ref="previewMain">
  <div class="doc-paper preview rirekisho">
    <div class="flex">
      <div class="rirekisho-box1 full">
        <div class="rirekisho-header">
          <div class="title slim">履歴書</div>
          <div class="date"
               @click="goCardTo('create-date')"
               :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span> 現在
          </div>
        </div>
        <div class="rirekisho-profile"
             @click="$eventHub.$emit('go-card-to', 'profile')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input">{{ basicData.lastNameFurigana }}&emsp;{{ basicData.firstNameFurigana }}</div>
          </div>
          <div class="name slim flex">
            <div class="label">名前</div>
            <div class="input">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
          </div>
          <div class="etc slim flex">
            <div class="birthday"> <span class="year">{{ basicData.birthYear }}</span>年 <span class="month">{{ basicData.birthMonth }}</span>月 <span class="day">{{ basicData.birthDay }}</span>日生（満 <span class="age">{{ age }}</span> 歳）</div>
            <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">男</span><span v-if="!isGenderDisplay">・</span>
              <span class="female" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isFemale}">女</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="rirekisho-box2">
      <div class="contact-information contact-main flex">
        <div class="contact-information-address"
             @click="$eventHub.$emit('go-card-to', 'address')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input"
                 :class="{'font-size-sm': ($formLib.charCount(basicData.addressFurigana) > 59) }">{{ basicData.addressFurigana }}</div>
          </div>
          <div class="address flex">
            <div class="label">現住所</div>
            <div class="input">
              <div class="postal-code">&#12306;{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
              <pre>{{ basicData.address1}} {{ basicData.address2 }}</pre>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             @click="$eventHub.$emit('go-card-to', 'contacts')">
          <div class="tel flex">
            <div class="label">電話</div>
            <div class="input">{{ tel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input">{{ basicData.email }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-table rirekisho-table-slim rirekisho-history-1"
         @click="$eventHub.$emit('go-card-to', 'edu-history')">
      <table>
        <thead>
          <tr>
            <th>年</th>
            <td>月</td>
            <td>学歴・職歴</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable"
              v-bind:class="item.classObject"
              v-if="index <= 9"
              :key="index">
            <th>{{ item.year }}</th>
            <td>{{ item.month }}</td>
            <td>{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-table rirekisho-table-slim rirekisho-skill"
         @click="$eventHub.$emit('go-card-to', 'license-history')"
         :id="idPrefix + 'preview-page-02'">
      <table :class="{error:this.errorMessages.licenseHistory}">
        <thead>
          <tr>
            <th>年</th>
            <td>月</td>
            <td>免許・資格</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licenseHistoryTable"
              v-bind:class="item.classObject"
              v-if="index <= 3"
              :key="index">
            <th>{{ item.year }}</th>
            <td>{{ item.month }}</td>
            <td>{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-pr-slim">
      <div class="rirekisho-pr-reason"
           @click="$eventHub.$emit('go-card-to', 'reason')">
        <div class="label">志望動機・特技・アピールポイントなど</div>
        <div class="input">
          <pre ref="reason"
               :class="classObject.reason">{{ formatData.reason }}</pre>
        </div>
      </div>
      <div class="rirekisho-pr-etc"
           @click="$eventHub.$emit('go-card-to', 'others')">
        <div class="time">
          <div class="label">通勤時間</div>
          <div class="input text-right">約 <span>{{ formatData.commuteHours }}</span> 時間 <span>{{ formatData.commuteMinutes }}</span> 分</div>
        </div>
        <div class="family">
          <div class="label">扶養家族数（配偶者を除く）</div>
          <div class="input text-right"><span>{{ formatData.spouseNumber }}</span> 人</div>
        </div>
        <div class="partner">
          <div class="existence">
            <div class="label">配偶者</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.hasSpouse}">有</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.hasSpouse}">無</span></div>
          </div>
          <div class="support">
            <div class="label">配偶者の扶養義務</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.underDutyToSupport}">有</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.underDutyToSupport}">無</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-hope-slim"
         @click="$eventHub.$emit('go-card-to', 'requests')">
      <div class="label">本人希望欄</div>
      <div class="input">
        <pre ref="request"
             :class="classObject.request">{{ formatData.request }}</pre>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RirekishoPreviewMixin from '@/mixins/rirekisho-preview-mixin'
export default {
  name: 'rirekishoNophotoPreview',
  mixins: [RirekishoPreviewMixin],
  data: function () {
    return {
      maxEduJobRows: 10,
      maxLicenseRows: 4,
      textareaMaxHeights: {
        reason: 60,
        request: 72
      },
      optionItems: {
        commuteDescription: false
      }
    }
  }
}
</script>
